import React, { useEffect, useState } from 'react';
import PaymentField from './PaymentField';


const AddPayment = () => {
     return (
        <div className='mx-auto p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A Payment</h1>
            <PaymentField></PaymentField>
        </div>
    );
};

export default AddPayment;